import {TypeAdresseComplete} from './TypeAdresseComplete';
import {Envoi} from './Envoi';
import {TypeAnnexeATA} from './TypeAnnexeATA';
import {RensComplementaires} from './RensComplementaires';
export class TypeRensA {
	public typeRensSelect: string;

	public admOuTech: TypeAnnexeATA;

	public envoi: Envoi;

	public document: TypeAdresseComplete;

	public rensComplementaires: RensComplementaires;

	public admEtTech: TypeAdresseComplete;

	constructor() { 
		 		this.admOuTech = new TypeAnnexeATA();
		this.envoi = new Envoi();
		this.document = new TypeAdresseComplete();
		this.rensComplementaires = new RensComplementaires();
		this.admEtTech = new TypeAdresseComplete();
		this.typeRensSelect = '';
	}
}
